import React from 'react'
import PropTypes from 'prop-types'
import { Form as FinalForm } from 'react-final-form'

import { RailsForm } from '@support/RailsForm'
import { validate } from '@models/admin/organizationContacts'
import Form from './Form'

const New = ({ organization, o }) =>
  <RailsForm
    component={FinalForm}
    action='create'
    url={`/v4/o/${o}/admin/organizations/${organization.id}/contacts`}
    successUrl={`/v4/o/${o}/admin/organizations/${organization.id}/contacts`}
    validate={validate}
    render={(props) => (
      <Form
        {...props}
        title={I18n.t('v4/organization_contact.actions.new')}
        organization={organization}
        o={o}
      />
    )}
  />

New.propTypes = {
  organization: PropTypes.object,
  o: PropTypes.string
}

export default New
